module.exports = __webpack_public_path__ + "static/media/SF-6-A.c6a22520.mp3";